var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCertifiedCertificate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_442_5357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 37.5V42C13.5 43.1935 13.0259 44.3381 12.182 45.182C11.3381 46.0259 10.1935 46.5 9 46.5H30C31.1935 46.5 32.3381 46.0259 33.182 45.182C34.0259 44.3381 34.5 43.1935 34.5 42V7.82C34.5 6.688 35.376 1.5 40.5 1.5C42.0913 1.5 43.6174 2.13214 44.7426 3.25736C45.8679 4.38258 46.5 5.9087 46.5 7.5V13.5H34.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 1.5H22.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47406 17.9659L3.86406 29.7239C3.80701 30.0386 3.85189 30.3633 3.99216 30.6507C4.13244 30.9381 4.36079 31.1732 4.64397 31.3219C4.92715 31.4705 5.25038 31.5248 5.56659 31.477C5.88281 31.4292 6.1755 31.2817 6.40206 31.0559L10.5001 26.9559L14.6001 31.0559C14.8266 31.2817 15.1193 31.4292 15.4355 31.477C15.7517 31.5248 16.075 31.4705 16.3582 31.3219C16.6413 31.1732 16.8697 30.9381 17.01 30.6507C17.1502 30.3633 17.1951 30.0386 17.1381 29.7239L15.5381 17.9659",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 19.5C15.4706 19.5 19.5 15.4706 19.5 10.5C19.5 5.52944 15.4706 1.5 10.5 1.5C5.52944 1.5 1.5 5.52944 1.5 10.5C1.5 15.4706 5.52944 19.5 10.5 19.5Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.75C10.3517 9.75 10.2067 9.79399 10.0833 9.8764C9.95999 9.95881 9.86386 10.0759 9.80709 10.213C9.75033 10.35 9.73547 10.5008 9.76441 10.6463C9.79335 10.7918 9.86478 10.9254 9.96967 11.0303C10.0746 11.1352 10.2082 11.2066 10.3537 11.2356C10.4992 11.2645 10.65 11.2497 10.787 11.1929C10.9241 11.1361 11.0412 11.04 11.1236 10.9167C11.206 10.7933 11.25 10.6483 11.25 10.5C11.25 10.3011 11.171 10.1103 11.0303 9.96967C10.8897 9.82902 10.6989 9.75 10.5 9.75Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertifiedCertificate);
export default __webpack_public_path__ + "static/media/certified-certificate.5fb56dc1794cda06f846cc8bdc79f5e4.svg";
export { ForwardRef as ReactComponent };